import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class AllocationReport extends Component {

    constructor() {
        super();
        this.state = {
            stock: 'nav-item',
            objs: [],
            objsload: false,

            reports: [],
            reportload: false,

            stdate:'',
            eddate:'',
        }
    }
    componentDidMount() {
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    tabledata=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            retdata = this.state.reports.datas.map(value => {
                count = count + 1
                let url=myconfig.urlmovmentreport+"?veh_id="+value.veh_id+"&st="+value.st+"&ed="+value.ed
                let url2=myconfig.urlfrightreport+"?fright_id="+value.fright_id
                return (<tr>
                    <td>{count}</td>
                    <td>
                        <a href={url} target="_blank">Trip Report</a> |
                        <a href={url2} target="_blank">Fright Report</a>
                    </td>
                    <td>{value.fono}</td>
                    <td>{value.fright_no}</td>
                    <td>{value.type}</td>
                    <td>{value.subtype}</td>
                    <td>{value.tran_type}</td>
                    <td>{value.tran_name}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.dri_Lic_no}</td>
                    <td>{value.companyname}</td>
                    <td>{value.rr_code}</td>
                    <td>{value.orgin}</td>
                    <td>{value.destination}</td>
                    <td>{value.cargo_name}</td>
                    <td>{value.capacity}</td>
                    <td>{value.loadedweight}</td>
                    <td>{value.km}</td>
                    <td>{value.dateofallocation}</td>
                    <td>{value.dateofarivalatloadpoint}</td>
                    <td>{value.dateofloading}</td>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.dateofarivalatboarder}</td>
                    <td>{value.dateofdepartureatboarder}</td>
                    <td>{value.dateofarivalatoffloadpoint}</td>
                    <td>{value.dateofoffloading}</td>
                    <td>{value.transport_rate_q}</td>
                    <td>{value.cement_rate_q}</td>
                    <td>{value.cement_cost}</td>
                    <td>{value.totalcmentcost}</td>
                    <td>{value.rev}</td>
                    <td>{value.fuelrate}</td>
                    <td>{value.fuelcost}</td>
                    <td>{value.prediem}</td>
                    <td>{value.handling}</td>
                    <td>{value.commesa}</td>
                    <td>{value.boardercost}</td>
                    <td>{value.otherexpense}</td>
                    <td>{value.gp}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    getreport = (event) => {
        event.preventDefault()
        this.setState({
            reports: [],
            reportload: false,
        })
        let baseurl = myconfig.allocationreport;
        axios.post(baseurl, {
            stdate: this.state.stdate,
            eddate: this.state.eddate,
            id: this.state.id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data)
                this.setState({
                    reports: res.data,
                    stdate: res.data.state.stdate,
                    eddate: res.data.state.eddate,
                    reportload: true,
                })

            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    render() {
        return (
            <>
                <Nav type="allocationreport"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Trip Master</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={myconfig.urlwelcome}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item active">Trip Master</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Report Criteria</h3>
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive pt-3 px-2" style={{height: '500px'}}>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Start Date</label>
                                                        <input className="form-control" type="date" name="stdate"
                                                               onChange={this.inputmgt} value={this.state.stdate}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>End Date</label>
                                                        <input className="form-control" type="date" name="eddate"
                                                               onChange={this.inputmgt} value={this.state.eddate}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <button className="btn btn-outline-primary form-control" onClick={this.getreport}>
                                                            Get Report
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <th>#</th>
                                                <th>Action</th>
                                                <th>FO DATE</th>
                                                <th>FREIGHT ORDER #</th>
                                                <th>TYPE</th>
                                                <th>SUB-TYPE</th>
                                                <th>TRANSPORTER TYPE</th>
                                                <th>TRANSPORTER NAME</th>
                                                <th>TRUCK No.</th>
                                                <th>TRAILER NO</th>
                                                <th>DRIVER</th>
                                                <th>TELEPHONE NO</th>
                                                <th>LICENSE NO</th>
                                                <th>CUSTOMER</th>
                                                <th>Route-Code</th>
                                                <th>ORIGIN</th>
                                                <th>DESTINATION</th>
                                                <th>CARGO</th>
                                                <th>CAPACITY OF TRUCK</th>
                                                <th>LOADED WEIGHT</th>
                                                <th>TOTAL KMS (ONE WAY)</th>
                                                <th>DATE OF ALLOCATION</th>
                                                <th>ARRIVAL AT LOADING POINT</th>
                                                <th>LOADING</th>
                                                <th>DEPARTURE</th>
                                                <th>ARRIVVAL AT BORDER</th>
                                                <th>DEPARTURE FROM BORDER</th>
                                                <th>OFFLOADING POINT</th>
                                                <th>OFFLOADING</th>
                                                <th>TRANSPORT RATE PER QUINTAL</th>
                                                <th>CEMENT RATE PER QUINTAL</th>
                                                <th>COST OF CEMENT PER QTL</th>
                                                <th>TOTAL CEMENT COST</th>
                                                <th>REVENUE BIRR</th>
                                                <th>FUEL RATE</th>
                                                <th>FUEL COST</th>
                                                <th>PER DIEM</th>
                                                <th>HANDLING</th>
                                                <th>COMESA</th>
                                                <th>BORDER CHARGES</th>
                                                <th>ANY OTHER EXPENSE</th>
                                                <th>GP</th>
                                                </thead>
                                                <tbody>
                                                {this.tabledata()}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default AllocationReport;
